import React from 'react'
import PropTypes from 'prop-types'
import Facebook from '@mui/icons-material/Facebook'

const FacebookIcon = ({ height, width, ...more }) => {
	
	return (
		<Facebook
			height={height}
			width={width}
			{...more}
		/>
	)
}

FacebookIcon.propTypes = {
	height: PropTypes.number.isRequired,
	width: PropTypes.number.isRequired
}

export default FacebookIcon
